export default {
    inserted: function(el, { value }) {
        // console.log('inserted', el)
        el.focus()
    }
}